import React from 'react'

const BellIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M20.437 19.713l-1.502-2.505c-.694-1.155-1.06-2.48-1.06-3.827v-2.194c0-2.769-1.849-5.111-4.376-5.866V3.75c0-.965-.785-1.75-1.75-1.75S10 2.785 10 3.75v1.57c-2.527.756-4.375 3.098-4.375 5.867v2.194c0 1.348-.366 2.67-1.06 3.826l-1.502 2.505c-.081.135-.083.303-.005.44.078.138.222.223.38.223h16.625c.157 0 .303-.085.38-.221.078-.137.076-.307-.005-.441zM8.994 21.25c.493 1.03 1.538 1.75 2.755 1.75 1.217 0 2.262-.72 2.756-1.75H8.994z"/>
  </svg>
)

export default BellIcon
